import { Component, Input, OnInit } from '@angular/core';
import { Form, FormControl } from '@angular/forms';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-level-select',
  templateUrl: './level-select.component.html',
})
export class LevelSelectComponent implements OnInit {
  @Input() label = 'Level';

  @Input() disabled = false;

  @Input() fieldControl: FormControl;

  @Input() levels: Observable<any>;

  useDefaultValue = false;

  ngOnInit(): void {
    this.setInitialLevel();
  }

  setInitialLevel(): void {
    if (this.disabled) {
      this.fieldControl.disable();
    } else {
      this.useDefaultValue = !this.fieldControl.value;
      this.useDefaultValue ? this.fieldControl.disable() : this.fieldControl.enable();
    }
  }

  toggleSwitch(event: MatSlideToggleChange): void {
    if (event.checked) this.fieldControl.patchValue(null);
    this.useDefaultValue ? this.fieldControl.disable() : this.fieldControl.enable();
  }
}
